import type { Command, CommandsStore, IncomingCommand, PageDataCommand, StartCommand, TriggerAuctionCommand, } from "@/ts/types";
import { devtools } from "zustand/middleware";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
export const initialState = { commands: [] };
export const commandsStore = createStore<CommandsStore>()(devtools(subscribeWithSelector(immer((set, get) => ({
    ...initialState,
    actions: {
        addCommand: (command: IncomingCommand) => {
            let id = -1;
            set((state) => {
                id = state.commands.length;
                const updatedCommand: Command = {
                    ...command,
                    done: false,
                    id: id + 1,
                };
                state.commands = [...state.commands, updatedCommand];
            });
        },
    },
    selectors: {
        selectPageDataCommand: () => {
            const pageDataCommand = get().commands.findLast((cmd: Command) => cmd.cmd === "page data");
            if (pageDataCommand) {
                return pageDataCommand as PageDataCommand;
            }
            return undefined;
        },
        selectTriggerAuctionCommand: () => {
            const triggerAuctionCommand = get().commands.findLast((cmd: Command) => cmd.cmd === "trigger auction");
            if (triggerAuctionCommand) {
                return triggerAuctionCommand as TriggerAuctionCommand;
            }
            return undefined;
        },
        selectStartCommand: () => {
            const startCommand = get().commands.findLast((cmd: Command) => cmd.cmd === "start");
            if (startCommand) {
                return startCommand as StartCommand;
            }
            return undefined;
        },
    },
}))), {
    name: "Hydra-CommandsStore",
}));
